import { Funnel } from '@/types/funnel.ts';

/**
 * Filtra funis por página e status
 */
export function filterFunnels(
    funnels: Funnel[],
    page?: string,
    status?: 'active' | 'inactive'
): Funnel[] {
    return funnels.filter(funnel => {
        // Filtro por página
        if (page && !funnel.pages.some(p => p.page_id === page)) {
            return false;
        }

        // Filtro por status
        if (status === 'active' && !funnel.is_active) {
            return false;
        }
        if (status === 'inactive' && funnel.is_active) {
            return false;
        }

        return true;
    });
}

/**
 * Ordena funis
 */
export function sortFunnels(
    funnels: Funnel[],
    sortBy: 'created_at' | 'nome',
    sortOrder: 'asc' | 'desc'
): Funnel[] {
    const sorted = [...funnels].sort((a, b) => {
        let comparison = 0;

        if (sortBy === 'created_at') {
            comparison = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
        } else if (sortBy === 'nome') {
            comparison = a.nome.localeCompare(b.nome, 'pt-BR');
        }

        return sortOrder === 'asc' ? comparison : -comparison;
    });

    return sorted;
}

/**
 * Formata data para exibição
 */
export function formatDate(dateString: string): string {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(date);
}

/**
 * Formata data relativa (ex: "há 2 horas")
 */
export function formatRelativeDate(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) {
        return 'agora mesmo';
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return `há ${diffInMinutes} ${diffInMinutes === 1 ? 'minuto' : 'minutos'}`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return `há ${diffInHours} ${diffInHours === 1 ? 'hora' : 'horas'}`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) {
        return `há ${diffInDays} ${diffInDays === 1 ? 'dia' : 'dias'}`;
    }

    const diffInWeeks = Math.floor(diffInDays / 7);
    if (diffInWeeks < 4) {
        return `há ${diffInWeeks} ${diffInWeeks === 1 ? 'semana' : 'semanas'}`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    return `há ${diffInMonths} ${diffInMonths === 1 ? 'mês' : 'meses'}`;
}